// lbl.home
export const home = {
    title: "Hello World!",
};
